export default function isPresent<T>(val: T | null | undefined): val is T {
    return !!val || val === 0 || val === '';
}
